import AuthService from "../../utilities/services/auth.service";

import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { PackagesReportWrapper } from "../../components";

export default function PackagesReportPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <ModalProvider>
      <PackagesReportWrapper organization={organization} />
    </ModalProvider>
  );
}
